<template>
  <el-dialog title="新增题目" :visible="dialogFormVisible" width="800px" :close-on-click-modal="false" @close="close">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="排序" prop="sort">
        <el-input v-model.trim="form.sort" placeholder="请输入排序号"></el-input>
      </el-form-item>
      <el-form-item label="题目标题" prop="title">
        <el-input v-model.trim="form.title" placeholder="请输入题目标题"></el-input>
      </el-form-item>
      <el-form-item label="选项A">
        <el-input v-model.trim="form.selectA" placeholder="请输入选项A内容"></el-input>
      </el-form-item>
      <el-form-item label="选项B">
        <el-input v-model.trim="form.selectB" placeholder="请输入选项B内容"></el-input>
      </el-form-item>
      <el-form-item label="选项C">
        <el-input v-model.trim="form.selectC" placeholder="请输入选项C内容"></el-input>
      </el-form-item>
      <el-form-item label="选项D">
        <el-input v-model.trim="form.selectD" placeholder="请输入选项D内容"></el-input>
      </el-form-item>
      <el-form-item label="正确答案">
        <el-radio v-model="form.answer" label="A">A</el-radio>
        <el-radio v-model="form.answer" label="B">B</el-radio>
        <el-radio v-model="form.answer" label="C">C</el-radio>
        <el-radio v-model="form.answer" label="D">D</el-radio>
      </el-form-item>
      <el-form-item label="题目分值" prop="score">
        <el-input v-model.trim="form.score" placeholder="请输入题目分值"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="dialogFormVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { collegeSave, collegeInfo } from '@/api/plugins.js';
export default {
  name: 'goodlistedit',
  data() {
    return {
      form: {
        id: '',
        typeId: '',
        title: '',
        score: '',
        selectA: '',
        selectB: '',
        selectC: '',
        selectD: '',
        answer: '1'
      },
      rules: {},
      dialogFormVisible: false,
      typeList: []
    };
  },
  created() {},
  methods: {
    init(id, typeId) {
      this.dialogFormVisible = true;
      this.form.typeId = typeId;
      if (id) {
        collegeInfo({ id }).then((res) => {
          if (res.code == 1) {
            Object.assign(this.form, res.data);
          }
        });
      }
    },
    close() {
      this.dialogFormVisible = false;
      this.$emit('callbackClose');
    },
    save() {
      this.$refs.form.validate((flag) => {
        if (flag) {
          collegeSave(this.form).then((res) => {
            if (res.code == 1) {
              this.$baseMessage(res.msg, 'success');
              this.dialogFormVisible = false;
            }
          });
        }
      });
    },
    getUeditor() {}
  }
};
</script>